// extracted by mini-css-extract-plugin
export default {"homeBody":"index_homeBody__2Emi-"};